import { useParams } from 'react-router'
import { gql } from '@/lib/graphql/gql'
import { useIdCompany, useSuspenseQuery } from '@/lib/hooks'
import type {
  AppCustomDomainsQuery,
  AppCustomDomainsQueryVariables,
} from '@/lib/hooks/use-app-custom-domains.types.gen'

const APP_CUSTOM_DOMAINS_QUERY = gql`
  query AppCustomDomains($idCompany: String!, $appName: String!) {
    company(id: $idCompany) {
      app(name: $appName) {
        id
        serviceDomains @live {
          id
          type
        }
      }
    }
  }
`

export const useAppCustomDomains = () => {
  const { idCompany } = useIdCompany()
  const { appName = '' } = useParams()

  const { data } = useSuspenseQuery<
    AppCustomDomainsQuery,
    AppCustomDomainsQueryVariables
  >(APP_CUSTOM_DOMAINS_QUERY, {
    variables: { idCompany, appName },
  })

  const serviceDomains = data?.company?.app?.serviceDomains ?? []
  const customDomains = serviceDomains.filter(
    (domain: any) => domain.type === 'CUSTOM'
  )

  return {
    hasCustomDomains: customDomains.length > 0,
    customDomainsCount: customDomains.length,
  }
}
